const Promise = require('bluebird');

const Lazy = {
	load: lazies => {
		for (var i = 0, l = lazies.length; i < l; i++) {
			let lazy = lazies.eq(i);

			$.ajax({
				type: 'POST',
				url: '/api/lazy/' + lazy.data('c') + '/' + lazy.data('m') + '/',
				async: true,
				data: {
					carun: lazy.data('i')
				},
				success: function(html) {
					Lazy.replace(lazy, html);
				}
			})
		}
	},
	replace: (element, data) => {
		element.after(data);
		element.remove();
	},
	credits: caruns => {
		return new Promise( (ok, err) => {
			$.ajax({
				type: 'POST',
				url: '/api/lazy/car/credits/',
				async: true,
				dataType: 'json',
				data: {
					caruns: caruns
				},
				success: ok,
				error: err
			});
		});
	},
	loadPreviews: caruns => {
		return new Promise( (ok, err) => {
			$.ajax({
				type: 'POST',
				url: '/api/lazy/car/previews/',
				async: true,
				data: {
					caruns: caruns
				},
				success: ok,
				error: err
			});
		});
	}
}

export default Lazy